import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "draw-attendance__wrapper" }
const _hoisted_2 = { class: "draw-attendance__bold" }
const _hoisted_3 = { class: "draw-attendance-popup" }
const _hoisted_4 = ["innerHTML"]

import { computed } from "vue";
import TransitionFade from "@sazka/design-system/src/transitions/transition-fade.vue";
import { PlayerAccountStatusDrawDto } from "@/api-connector/ls-admin-public/models/player-api-models";


export default /*@__PURE__*/_defineComponent({
  __name: 'draw-attendance',
  props: {
    drawAttendancePopupVisible: { type: Boolean },
    draws: {}
  },
  emits: ["open-popup-banners-modal", "toggle-draw-attendance-popup"],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;

const props = __props;

const drawTextMaxIndex = computed(() => props.draws?.length - 1 || 0);

const drawsText = computed(() => {
    if (!props.draws || !props.draws.length) {
        return ["Nyní se neúčastníte <strong>žádného losování</strong>"];
    }

    return props.draws.map(
        (drawStatus, index) =>
            `${drawStatus.name} se zúčastníte <strong>${drawStatus.count}x</strong>${
                index != drawTextMaxIndex.value ? "," : ""
            }`
    );
});

const drawsTotalCount = computed(
    () => props.draws?.map((drawStatus) => drawStatus.count).reduce((acc, count) => acc + count, 0) ?? 0
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", {
      class: "draw-attendance-btn",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('toggle-draw-attendance-popup')))
    }, [
      _cache[2] || (_cache[2] = _createElementVNode("span", null, "Účast v losování:", -1)),
      _createElementVNode("span", _hoisted_2, _toDisplayString(drawsTotalCount.value) + "x", 1)
    ]),
    _createVNode(TransitionFade, null, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("section", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(drawsText.value, (drawText, index) => {
            return (_openBlock(), _createElementBlock("p", {
              key: index,
              class: "draw-attendance-popup__text",
              innerHTML: drawText
            }, null, 8, _hoisted_4))
          }), 128)),
          _createElementVNode("div", {
            class: "btn draw-attendance-popup__btn",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('open-popup-banners-modal')))
          }, " Zvyšte svou šanci na výhru ")
        ], 512), [
          [_vShow, _ctx.drawAttendancePopupVisible]
        ])
      ]),
      _: 1
    })
  ]))
}
}

})